import React from 'react';
import { useTranslation } from 'react-i18next';

import TextInputField from 'components/layout/forms/TextInputField';
import translations from 'services/translations/translations';

import IVersion from '../IVersion';
import OfferText from './OfferText';

/**
 * The name and the offer text of the active alternative (version): what is printed in the
 * offer PDF. The editor has the width of the text in the PDF.
 */
const Version = ({
  activeVersionIndex,
  locked,
  offerText,
  onOfferTextChanged,
  setVersions,
  versions,
}: {
  activeVersionIndex: number;
  locked: boolean;
  offerText: string;
  onOfferTextChanged: (value: string) => void;
  setVersions: (versions: IVersion[]) => void;
  versions: IVersion[];
}): JSX.Element => {
  const { t } = useTranslation([translations.common, translations.offers]);

  const onVersionNameChange = (event: any) =>
    setVersions(
      versions.map((version, index) =>
        index === activeVersionIndex
          ? { ...version, name: event.target.value }
          : version
      )
    );

  return (
    <>
      <TextInputField
        disabled={locked}
        id="offer-product-version-name"
        label={t(`${translations.common}:Name`)}
        name="offer-product-version-name"
        onChange={onVersionNameChange}
        required
        value={versions[activeVersionIndex].name}
      />
      <OfferText
        locked={locked}
        offerText={offerText}
        onOfferTextChanged={onOfferTextChanged}
      />
    </>
  );
};

export default Version;
